import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { completeTask } from "./schema/complete-task";
import { getInboundConsolidationDetails } from "./schema/get-inbound-consolidation-details";
import { getInboundConsolidationMetrics } from "./schema/get-inbound-consolidation-metrics";
import { getInboundShipmentMetrics } from "./schema/get-inbound-shipment-metrics";
import { getInventoryItems } from "./schema/get-inventory-items";
import { getInventoryItemsForExport } from "./schema/get-inventory-items-for-export";
import { getInventoryMetrics } from "./schema/get-inventory-metrics";
import { getInventorySkuAggregates } from "./schema/get-inventory-sku-aggregates";
import { getLatestRefulfillmentOrders } from "./schema/get-latest-refulfillment-orders";
import { getManagedReturnsLocations } from "./schema/get-managed-returns-locations";
import { getManagedReturnsMetrics } from "./schema/get-managed-returns-metrics";
import {
  getManagedReturnsOverviewMetrics,
  getOverviewRefulfillmentMetrics,
} from "./schema/get-managed-returns-overview-metrics";
import { getOrderFulfillmentAnalyticsAvailability } from "./schema/get-order-fulfillment-analytics-availability";
import { getRecentReturns } from "./schema/get-recent-returns";
import { getRefulfillmentMetrics } from "./schema/get-refulfillment-metrics";
import {
  getReturnNetworkProducts,
  getReturnNetworkProductsForExport,
} from "./schema/get-return-network-products";
import { getReturnProcessingLevel } from "./schema/get-return-processing-level";
import { getReturnsCenters } from "./schema/get-returns-centers";
import { getTasks } from "./schema/get-tasks";
import { getTasksMetrics } from "./schema/get-tasks-metrics";
import { getGradeMappings, updateGradeMappings } from "./schema/grade-mappings";
import {
  getInboundConsolidationManifestCsv,
  getInboundConsolidationManifestPdf,
  listInboundConsolidationDocuments,
} from "./schema/inbound-consolidation-documents";
import { getInventoryItemLifecycle } from "./schema/inventory-rules/inventory-item-lifecycle";
import {
  deleteInventoryLane,
  listInventoryLanes,
  reorderInventoryLanes,
  saveInventoryLane,
} from "./schema/inventory-rules/inventory-lanes";
import {
  getInventoryRuleCoverage,
  previewInventoryRuleImpact,
} from "./schema/inventory-rules/inventory-rule-impact";
import {
  applyInventoryRuleSettings,
  listInventoryRuleSettings,
} from "./schema/inventory-rules/inventory-rule-settings";
import { listInventoryRuleWarehouses } from "./schema/inventory-rules/inventory-rule-warehouses";
import {
  deleteInventoryRule,
  getInventoryRule,
  listInventoryRules,
  reorderInventoryRules,
  saveInventoryRule,
  setInventoryRuleStatus,
} from "./schema/inventory-rules/inventory-rules";
import { listInboundConsolidatedShipments } from "./schema/list-inbound-consolidated-shipments";
import { listInboundConsolidationItems } from "./schema/list-inbound-consolidation-items";
import { listInboundConsolidations } from "./schema/list-inbound-consolidations";
import { listManufacturers } from "./schema/list-manufacturers";
import { listSupportedOutcomes } from "./schema/list-supported-outcomes";
import {
  getManagedReturnsIntegrations,
  getManagedReturnsIntegrationSettings,
  updateManagedReturnsIntegrationSettings,
} from "./schema/managed-returns-integrations";
import { saveManagedReturnsSettings } from "./schema/save-managed-returns-settings";
import { updateReturnNetworkProductVariant } from "./schema/update-return-network-product-variant";

export const rpcDefinition = {
  applyInventoryRuleSettings,
  completeTask,
  deleteInventoryLane,
  deleteInventoryRule,
  getGradeMappings,
  getInboundConsolidationDetails,
  getInboundConsolidationManifestCsv,
  getInboundConsolidationManifestPdf,
  getInboundConsolidationMetrics,
  getInboundShipmentMetrics,
  getInventoryItemLifecycle,
  getInventoryItems,
  getInventoryItemsForExport,
  getInventoryMetrics,
  getInventoryRule,
  getInventoryRuleCoverage,
  getInventorySkuAggregates,
  getLatestRefulfillmentOrders,
  getManagedReturnsIntegrations,
  getManagedReturnsIntegrationSettings,
  updateManagedReturnsIntegrationSettings,
  getManagedReturnsLocations,
  getManagedReturnsMetrics,
  getManagedReturnsOverviewMetrics,
  getOverviewRefulfillmentMetrics,
  getOrderFulfillmentAnalyticsAvailability,
  getRecentReturns,
  getRefulfillmentMetrics,
  getReturnNetworkProducts,
  getReturnNetworkProductsForExport,
  getReturnProcessingLevel,
  getTasks,
  getTasksMetrics,
  listInboundConsolidatedShipments,
  listInboundConsolidationDocuments,
  listInboundConsolidationItems,
  listInboundConsolidations,
  listInventoryLanes,
  listInventoryRuleSettings,
  listInventoryRuleWarehouses,
  listInventoryRules,
  previewInventoryRuleImpact,
  reorderInventoryLanes,
  reorderInventoryRules,
  getReturnsCenters,
  saveInventoryLane,
  saveInventoryRule,
  saveManagedReturnsSettings,
  setInventoryRuleStatus,
  listManufacturers,
  listSupportedOutcomes,
  updateGradeMappings,
  updateReturnNetworkProductVariant,
};

export type RedoManagedReturnsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
